<template lang="html">
  <transition name="fadeInSubtle">
    <div class="login-screen" v-bind:style="isLoading ? { transform: 'none !important'} : {}">

      <div class="loader-wrapper">
        <div v-show="isLoading" class="loader"></div>
      </div>

      <div v-show="!isLoading" class="login-wrapper">

        <h2 class="header">{{ $t('login.enter_portal') }}</h2>

        <hr />

        <p class="login-info">{{ $t('login.insert_credentials') }}</p>

        <form class="form" @submit.prevent="submit()" @keyup.13>

          <label class="form__label">
            <input
              type="email"
              class="form__credentials-input"
              v-model="credentials.email"
              name="email"
              :placeholder="$t('common.email')"
            >
          </label>

          <label class="form__label">
            <input
              type="password"
              class="form__credentials-input"
              v-model="credentials.password"
              :placeholder="$t('login.password') "
              v-validate data-vv-rules="required"
              data-vv-delay="2000"
              name="password"
            >
          </label>

          <div class="form-info">

            <label>
              <input type="checkbox" class="form-info__checkbox" role="remember username and password">
              <span @click="toggleCheckbox"  class="form-info__custom-checkbox"></span>
              <span class="form-info__checkbox-description">{{ $t('login.remember_me') }}</span>
            </label>

            <router-link :to="{ name: 'reset' }" class="form-info__forgot-password">{{ $t('login.forgot_password') }} </router-link>

          </div>

          <button  class="form__login-button btn" @click.stop.prevent="submit()">{{ $t('login.login') }}</button>

          <div class="form__error" v-if="error">
            <p class="form_error--message">{{ error.message }}</p>
          </div>

          <div class="form__error" v-show="errors.has('password')">
            {{ $t('login.password_required') }}
          </div>

        </form>

      </div>


    </div>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'login-form',
    props: [],
    data() {
      return {
        credentials: {
          email: '',
          password: '',
        },
        error: {
          message: '',
        },
        isLoading: false,
        checkboxIsActive: false,
        notificationInstance: null
      };
    },
    computed: mapGetters({
      user: 'user/user/user',
      userError: 'user/user/error',
    }),
    created() {
      /*
       Show notification functionality for non-auth. users.
       - enable next code to make it working again.
       - change the notification message in the openNotification method.
       */
      // if (!this.user.authenticated) {
      //   this.notificationInstance = this.openNotification()
      // }
    },
    methods: {
      openNotification() {
        return this.$notify.warning({
          title: '',
          dangerouslyUseHTMLString: true,
          message:  this.$t('notification'),
          duration: 0,
          offset: 100,
          customClass: 'notification',
        });
      },
      submit() {
        if (this.notificationInstance) {
          this.notificationInstance.close()
        }
        this.$validator.validateAll().then((success) => {
          if (success) {
            this.isLoading = true;
            const credentials = {
              email: this.credentials.email,
              password: this.credentials.password,
            };
            this.$store.dispatch('user/user/login', credentials).then((res) => {
              this.isLoading = false;
              if (this.userError === '') {
                this.$router.push({ name: 'dashboard' });
                this.$store.dispatch('user/user/checkAuth', res);
              } else if (this.userError === 401) {
                this.error.message = this.$t('errors.401');
              } else if (this.userError === 422) {
                this.error.message = this.$t('errors.422');
              }
            });
          }
        })
          .catch(() => {
            this.error.message = this.$t('errors.422');
          });
      },
      toggleCheckbox() {
        this.checkboxIsActive = !this.checkboxIsActive;
      },
    },
  };
</script>

<style lang="scss">
@import '~styles/app.scss';

  .login-screen {

    .login-wrapper {
      padding: 20px 60px;

      @media screen and (max-width: 565px) {
        padding: 20px 30px!important;
      }

      @media screen and (max-width: 359px) {
        padding: 10px 15px!important;
      }


      .header {
        font-weight: 400;
        padding: 0 0 5px 0;

        @media screen and (max-height: 740px) { /* was 650px */
          margin: 10px 0;
        }

      }

      .login-info {
        font-size: 12px;
        margin: 35px 0 55px 0;
        padding: 0 10px;

        @media screen and (max-height: 740px) {
          margin: 10px 0;
        }

      }

      .form {
        position: relative;

        &__label {
          width: 100%;
          display: flex;
        }
      }

      &__error {
        margin: 10px 0;
        text-align: center;
        color: var(--brand-red);

        .form_error--message {
          font-weight: 900;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/LoginForm.vue